exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/** Button按钮间距 */\n.ant-btn[data-v-5427812c] {\n  margin-left: 30px;\n  margin-bottom: 30px;\n  float: right;\n}\n.drawer-footer[data-v-5427812c] {\n  position: absolute;\n  bottom: -8px;\n  width: 100%;\n  border-top: 1px solid #e8e8e8;\n  padding: 10px 16px;\n  text-align: right;\n  left: 0;\n  background: #fff;\n  border-radius: 0 0 2px 2px;\n}\n", ""]);

// exports
